import { render, staticRenderFns } from "./trainSignUpTableNeiBu.vue?vue&type=template&id=525a0198"
import script from "./trainSignUpTableNeiBu.vue?vue&type=script&lang=js"
export * from "./trainSignUpTableNeiBu.vue?vue&type=script&lang=js"
import style0 from "./trainSignUpTableNeiBu.vue?vue&type=style&index=0&id=525a0198&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports